import take from '../take';

export default function dropLast(n, xs) {
  return take(n < xs.length ? xs.length - n : 0, xs);
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-ramda/~/ramda/es/internal/_dropLast.js
// module id = 2537
// module chunks = 1